import { getNetworkError } from '@/util/network';
import { AppDispatch } from '../..';
import { apolloClient } from '../../../service/apolloClient';
import { callback } from '../base';
import { toastAction } from '../toastAction';
import { setIsGameLeadSubmitPending } from '@/redux/reducer/game';
import { IGameLeadInput } from '@/interface/gameLead';
import { CREATE_GAME_USER_INFO_GQL } from '@/redux/query/gameUserInfo';
import { signRequestPayload } from '@/helper/encrypt';

export const gameUserInfoCreateAction = (
  input: IGameLeadInput,
  cb?: callback
) => {
  const mutation = CREATE_GAME_USER_INFO_GQL;
  const sign = signRequestPayload(input);
  return (dispatch: AppDispatch) => {
    dispatch(setIsGameLeadSubmitPending(true));
    apolloClient
      .mutate({ mutation, variables: { input: { sign } } })
      .then(({ data }) => {
        const { createGameUserInfo: res } = data;
        if (!res) return;
        if (cb) cb();

        toastAction.success('Your Information has been Submitted');
      })
      .catch(err => {
        const errmsg = getNetworkError(err);
        toastAction.error(errmsg);
      })
      .finally(() => {
        dispatch(setIsGameLeadSubmitPending(false));
      });
  };
};
